import React, { FunctionComponent } from 'react';
import { usePosts } from 'hooks';
import { WPAcfUseCases } from 'types/acf/useCases';
import PostItems from '../PostItems/PostItems';
import { useIntl } from 'react-intl';
import messages from 'messages/base-pl';
import { useRouteTranslations } from 'utils/languages';
import styles from './CaseStudyItems.module.scss';

interface OwnProps {
  data: WPAcfUseCases | null;
  showMore?: boolean;
  loadMore?: boolean;
}

type CaseStudyItemsProps = JSX.IntrinsicElements['div'] & OwnProps;

const CaseStudyItems: FunctionComponent<CaseStudyItemsProps> = props => {
  const POSTS_PER_PAGE = 4;
  const { formatMessage } = useIntl();
  const { translateSlug } = useRouteTranslations();
  const { data, showMore, loadMore } = props;

  const { header, buttonLabel = formatMessage(messages.caseStudy_button), posts, selected } = data || {};

  const { data: caseStudies } = usePosts({
    category_name: 'case_study',
    ...(selected && { slug: selected }),
  });

  if (!caseStudies || caseStudies.length === 0) {
    return null;
  }

  return (
    <PostItems
      mobile={1}
      tablet={2}
      desktop={2}
      category={translateSlug('case_studies')}
      posts={caseStudies}
      header={header}
      linkLabel={buttonLabel}
      length={parseInt(posts || '') || POSTS_PER_PAGE}
      showMore={showMore}
      loadMore={loadMore}
      className={styles.wrapper}
      seeMoreLabel={formatMessage(messages.show_more_case_studies)}
    />
  );
};

export default CaseStudyItems;
